<script lang="ts">
	import { onMount } from 'svelte';
	import BrandMark from './BrandMark.svelte';
	import Icon from './Icon.svelte';

	let menuOpen = $state(false);
	let menuButton = $state<HTMLButtonElement>();
	let hydrated = $state(false);
	const closeMenu = () => (menuOpen = false);
	const closeOnEscape = (event: KeyboardEvent) => {
		if (event.key === 'Escape' && menuOpen) {
			closeMenu();
			menuButton?.focus();
		}
	};

	onMount(() => {
		hydrated = true;
	});
</script>

<svelte:window onkeydown={closeOnEscape} />

<header class="site-header">
	<div class="page header-inner">
		<a class="brand" href="/" aria-label="ANDRESOT — на главную" onclick={closeMenu}>
			<BrandMark size={42} decorative />
			<span class="brand-word">ANDRESOT</span>
		</a>

		<nav
			id="site-navigation"
			class:open={menuOpen}
			class="site-nav"
			aria-label="Основная навигация"
		>
			<a href="/#product" onclick={closeMenu}>Возможности</a>
			<a href="/#technology" onclick={closeMenu}>Приватность</a>
			<a href="/download/" onclick={closeMenu}>Установка</a>
			<a href="/#faq" onclick={closeMenu}>Вопросы</a>
		</nav>

		<div class="header-actions">
			<a class="button small" href="https://web.andresot.ru" aria-label="Открыть ANDRESOT">
				<span>Открыть</span><Icon name="external" size={17} />
			</a>
			<button
				bind:this={menuButton}
				class="menu-toggle"
				type="button"
				aria-label={menuOpen ? 'Закрыть меню' : 'Открыть меню'}
				aria-expanded={menuOpen}
				aria-controls="site-navigation"
				disabled={!hydrated}
				onclick={() => (menuOpen = !menuOpen)}
			>
				<Icon name={menuOpen ? 'close' : 'menu'} size={22} />
			</button>
		</div>
	</div>
</header>
